import React, { useEffect, useMemo, useState } from "react";
import { ImagePlus, Trash2 } from "lucide-react";
import { Autocomplete, TextField } from "@mui/material";

function AddLocalComponents({
    id,
    mode,
    razonSocial, setRazonSocial,
    imagen, setImagen,
    telefono, setTelefono,
    ubicacion, setUbicacion,
    descripcion, setDescripcion,
    ruc, setRuc,
    nombreFantasia, setNombreFantasia,
    cantidadPersonasEnLocal, setCantidadPersonasEnLocal,
    isTelefonoWhatsapp, setIsTelefonoWhatsapp,
    isParticipaGiftCard, setIsParticipaGiftCard,
    categorias, categoriaSelected,
    handleUpdate,
    handleAgregarImagen,
    handleCancelar,
    handleGuardar,
    handleCategoriaSelected,
    categoriaQuery, setCategoriaQuery
}) {





    return (
        <div className="rounded-xl bg-white p-6 shadow-xl">
            <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
                <div>
                    {mode === "view" ? (
                        <div className="relative aspect-square w-full overflow-hidden rounded-2xl border border-gray-200 bg-[#f1f5f9]">
                            {imagen ? (
                                <img
                                    src={imagen}
                                    alt="imagen local"
                                    className="h-full w-full object-cover"
                                />
                            ) : (
                                <div className="flex h-full flex-col items-center justify-center p-6 text-center">
                                    <p className="text-base font-semibold text-gray-700">No hay imagen</p>
                                    <p className="mb-5 text-sm text-gray-500">Tamaño requerido: 720 x 720</p>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="relative aspect-square w-full overflow-hidden rounded-2xl border border-gray-200 bg-[#f1f5f9]">
                            {imagen ? (
                                <>
                                    <button
                                        type="button"
                                        onClick={() => setImagen("")}
                                        className="absolute right-3 top-3 z-10 rounded-lg bg-black/45 p-2 text-white transition-colors hover:bg-black/60"
                                    >
                                        <Trash2 size={18} />
                                    </button>
                                    <img
                                        src={imagen}
                                        alt="imagen local"
                                        className="h-full w-full object-cover"
                                    />
                                </>
                            ) : (
                                <div className="flex h-full flex-col items-center justify-center p-6 text-center">
                                    <p className="text-base font-semibold text-gray-700">No hay imagen</p>
                                    <p className="mb-5 text-sm text-gray-500">Tamaño requerido: 720 x 720</p>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        className="hidden"
                                        id="file-input"
                                        onChange={handleAgregarImagen}
                                    />
                                    <label htmlFor="file-input" className="cursor-pointer">
                                        <span className="inline-flex items-center gap-2 rounded-lg bg-[#104063] px-5 py-2.5 font-medium text-white transition-colors hover:bg-[#0d3553]">
                                            <ImagePlus size={16} />
                                            Agregar imagen
                                        </span>
                                    </label>
                                </div>
                            )}
                        </div>
                    )}

                </div>

                <div className="grid grid-cols-1 gap-4">
                    <div>
                        <label className="mb-1.5 block text-sm font-semibold text-gray-700">Razón social</label>
                        <input
                            type="text"
                            value={razonSocial}
                            onChange={(e) => setRazonSocial(e.target.value)}
                            autoCapitalize="none"
                            disabled={mode === "view"}
                            autoCorrect="off"
                            className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                        />
                    </div>

                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                        <div>
                            <label className="mb-1.5 block text-sm font-semibold text-gray-700">RUC</label>
                            <input
                                type="text"
                                value={ruc}
                                onChange={(e) => setRuc(e.target.value)}
                                autoCapitalize="none"
                                disabled={mode === "view"}
                                autoCorrect="off"
                                className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                            />
                        </div>

                        <div>
                            <label className="mb-1.5 block text-sm font-semibold text-gray-700">Teléfono</label>
                            <input
                                type="text"
                                value={telefono}
                                onChange={(e) => setTelefono(e.target.value)}
                                autoCapitalize="none"
                                disabled={mode === "view"}
                                autoCorrect="off"
                                className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                            />
                        </div>
                    </div>

                    <div>
                        <label className="mb-1.5 block text-sm font-semibold text-gray-700">Nombre de fantasía</label>
                        <input
                            type="text"
                            value={nombreFantasia}
                            onChange={(e) => setNombreFantasia(e.target.value)}
                            autoCapitalize="none"
                            disabled={mode === "view"}
                            autoCorrect="off"
                            className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                        />
                    </div>

                    <div>
                        <label className="mb-1.5 block text-sm font-semibold text-gray-700">Categoría</label>
                        <Autocomplete
                            disablePortal
                            options={categorias}
                            fullWidth
                            disabled={mode === "view"}
                            value={categoriaSelected || null}
                            getOptionLabel={(option) => option?.nombre || ""}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            filterOptions={(options) => options}
                            onInputChange={(event, newInputValue, reason) => {
                                if (reason === "input") {
                                    setCategoriaQuery(newInputValue);
                                }
                            }}
                            onChange={(event, value) => {
                                handleCategoriaSelected(value);
                            }}
                            loadingText={"Cargando..."}
                            noOptionsText={"No hay opciones"}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Seleccione categoría"
                                    size="small"
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: '#f1f5f9',
                                            borderRadius: '0.5rem',
                                            fontSize: '0.875rem',
                                        },
                                    }}
                                />
                            )}
                        />
                    </div>

                    <div>
                        <label className="mb-1.5 block text-sm font-semibold text-gray-700">Ubicación</label>
                        <input
                            type="text"
                            value={ubicacion}
                            onChange={(e) => setUbicacion(e.target.value)}
                            autoCapitalize="none"
                            autoCorrect="off"
                            className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                            disabled={mode === "view"}
                        />
                    </div>

                    <div>
                        <label className="mb-1.5 block text-sm font-semibold text-gray-700">Cantidad máxima de personas en el local</label>
                        <input
                            type="number"
                            value={cantidadPersonasEnLocal}
                            onChange={(e) => setCantidadPersonasEnLocal(e.target.value)}
                            autoCapitalize="none"
                            autoCorrect="off"
                            className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                            disabled={mode === "view"}
                        />
                    </div>

                    <div>
                        <label className="mb-1.5 block text-sm font-semibold text-gray-700">Descripción</label>
                        <textarea
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                            autoCapitalize="none"
                            autoCorrect="off"
                            rows={4}
                            className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                            disabled={mode === "view"}
                        />
                    </div>

                    <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center">
                        <label className="inline-flex items-center gap-2 text-sm text-gray-700">
                            <input
                                type="checkbox"
                                checked={isTelefonoWhatsapp}
                                onChange={(e) => setIsTelefonoWhatsapp(e.target.checked)}
                                className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                disabled={mode === "view"}
                            />
                            Teléfono con WhatsApp
                        </label>

                        <label className="inline-flex items-center gap-2 text-sm text-gray-700">
                            <input
                                type="checkbox"
                                checked={isParticipaGiftCard}
                                onChange={(e) => setIsParticipaGiftCard(e.target.checked)}
                                className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                disabled={mode === "view"}
                            />
                            Participa Gift Card
                        </label>
                    </div>





                </div>
            </div>

            <div className="mt-4 flex flex-wrap items-center gap-4 border-t border-gray-200 pt-6">
                {mode !== "view" && (
                    <button
                        type="button"
                        onClick={id ? handleUpdate : handleGuardar}
                        className="rounded-lg bg-[#104063] px-6 py-2 font-medium text-white transition-colors hover:bg-[#0d3553]"
                    >
                        Guardar
                    </button>
                )}
                <button
                    type="button"
                    onClick={handleCancelar}
                    className="rounded-lg bg-gray-100 px-6 py-2 font-medium text-gray-700 transition-colors hover:bg-gray-200"
                >
                    Cancelar
                </button>
            </div>

        </div>
    );
}

export default AddLocalComponents;